export default __webpack_public_path__ + "static/media/purchase.a2d4fdcd.svg";